// import { Card, Typography } from '@material-ui/core'
// import React, { useEffect, useState } from 'react'
// import axios from 'axios'

// interface Activity {
// 	_id: string
// 	status: string
// 	browser: string
// 	os: string
// 	timestamp: string
// 	activitytype: string
// 	unusual_activity_count: number
// }

// const UnusualActivities = ({ assessId, uuid }: { assessId: string; uuid: string }) => {
// 	const userId = localStorage.getItem('userId')
// 	const [activities, setActivities] = useState<Activity[]>([])

// 	useEffect(() => {
// 		const fetchActivities = async () => {
// 			try {
// 				const response = await axios.post(
// 					`${process.env.REACT_APP_API_URL}/api/v1/sandbox/get_activity`,
// 					{
// 						userId: uuid,
// 						assessmentId: assessId
// 					}
// 				)
// 				if (response.data?.success) {
// 					setActivities(response.data.data.activities)
// 					console.log('sekhar', assessId)
// 				}
// 			} catch (error) {
// 				console.error('Failed to fetch activities:', error)
// 			}
// 		}

// 		if (userId && assessId) {
// 			fetchActivities()
// 		}
// 	}, [userId, assessId])

// 	useEffect(() => {
// 		console.log('Assessment ID:chandu:sekhar', assessId)
// 	}, [assessId])

// 	return (
// 		<div>
// 			<Card style={{ padding: '0px 10px' }}>
// 				<Typography variant="h6" style={{ fontWeight: 'bold', marginTop: '16px' }}>
// 					Log Activity
// 				</Typography>
// 				{activities.length === 0 ? (
// 					<Typography
// 						variant="body1"
// 						style={{
// 							marginTop: '16px',
// 							marginBottom: '16px',
// 							textAlign: 'center',
// 							color: 'gray'
// 						}}
// 					>
// 						Log Activity is not found
// 					</Typography>
// 				) : (
// 					<div style={{ display: 'flex', gap: '2px', flexDirection: 'column' }}>
// 						{activities.map(activity => (
// 							<Card
// 								key={activity._id}
// 								style={{
// 									width: '100%',
// 									backgroundColor: 'rgba(241, 241, 255, 0.3)',
// 									boxShadow: 'none',
// 									padding: '10px',
// 									marginTop: '12px',
// 									borderRadius: '12px',
// 									display: 'flex',
// 									flexDirection: 'column'
// 								}}
// 							>
// 								<div
// 									style={{
// 										display: 'flex',
// 										flexDirection: 'row',
// 										justifyContent: 'space-between',
// 										paddingRight: 100
// 									}}
// 								>
// 									<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
// 										<div
// 											style={{
// 												display: 'flex',
// 												flexDirection: 'column',
// 												gap: '3px'
// 											}}
// 										>
// 											<Typography variant="body2" color="textSecondary">
// 												Status :
// 											</Typography>
// 											<Typography variant="body1">{activity.status}</Typography>
// 										</div>
// 										<div
// 											style={{
// 												display: 'flex',
// 												flexDirection: 'column',
// 												gap: '3px'
// 											}}
// 										>
// 											<Typography variant="body2" color="textSecondary">
// 												Browser :
// 											</Typography>
// 											<Typography variant="body1">{activity.browser}</Typography>
// 										</div>
// 									</div>
// 									<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
// 										<div
// 											style={{
// 												display: 'flex',
// 												flexDirection: 'column',
// 												gap: '3px'
// 											}}
// 										>
// 											<Typography variant="body2" color="textSecondary">
// 												OS :
// 											</Typography>
// 											<Typography variant="body1">{activity.os}</Typography>
// 										</div>

// 										<div
// 											style={{
// 												display: 'flex',
// 												flexDirection: 'column',
// 												gap: '3px'
// 											}}
// 										>
// 											<Typography variant="body2" color="textSecondary">
// 												Timestamp :
// 											</Typography>
// 											<Typography variant="body1">
// 												{' '}
// 												{new Date(activity.timestamp).toLocaleDateString()}
// 											</Typography>
// 										</div>
// 									</div>
// 									<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
// 										<div
// 											style={{
// 												display: 'flex',
// 												flexDirection: 'column',
// 												gap: '3px'
// 											}}
// 										>
// 											<Typography variant="body2" color="textSecondary">
// 												Time :
// 											</Typography>
// 											<Typography variant="body1">
// 												{' '}
// 												{new Date(activity.timestamp).toLocaleTimeString([], {
// 													hour: '2-digit',
// 													minute: '2-digit',
// 													hour12: true
// 												})}
// 											</Typography>
// 										</div>
// 										<div
// 											style={{
// 												display: 'flex',
// 												flexDirection: 'column',
// 												gap: '3px'
// 											}}
// 										>
// 											<Typography variant="body2" color="textSecondary">
// 												Activity Type :
// 											</Typography>
// 											<Typography variant="body1">{activity.activitytype}</Typography>
// 										</div>
// 									</div>
// 								</div>
// 							</Card>
// 						))}
// 					</div>
// 				)}
// 			</Card>
// 		</div>
// 	)
// }

// export default UnusualActivities
import { Card, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import axios from 'axios'

interface Activity {
	_id: string
	status: string
	browser: string
	os: string
	timestamp: string
	activitytype: string
	unusual_activity_count: number
}

const UnusualActivities = ({ assessId, uuid }: { assessId: string; uuid: string }) => {
	const userId = localStorage.getItem('userId')
	const [activities, setActivities] = useState<Activity[]>([])
	const [highestActivityCount, setHighestActivityCount] = useState<number>(0)

	useEffect(() => {
		const fetchActivities = async () => {
			try {
				const response = await axios.post(
					`${process.env.REACT_APP_API_URL}/api/v1/sandbox/get_activity`,
					{
						userId: uuid,
						assessmentId: assessId
					}
				)
				if (response.data?.success) {
					setActivities(response.data.data.activities)
					setHighestActivityCount(response.data.data.highestActivityCount || 0)
				}
			} catch (error) {
				console.error('Failed to fetch activities:', error)
			}
		}

		if (userId && assessId) {
			fetchActivities()
		}
	}, [userId, assessId])

	return (
		<div>
			<Card>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						marginTop: '5px'
						// padding: '0px 10px'
					}}
				>
					<Typography variant="h6" style={{ fontWeight: 'bold' }}>
						Log Activity
					</Typography>
					<Typography variant="body2" color="textSecondary" style={{ fontWeight: 'bold' }}>
						Activity Count: {activities.length}
					</Typography>
				</div>

				{activities.length === 0 ? (
					<Typography
						variant="body1"
						style={{
							marginTop: '16px',
							marginBottom: '16px',
							textAlign: 'center',
							color: 'gray'
						}}
					>
						Log Activity is not found
					</Typography>
				) : (
					<div style={{ display: 'flex', gap: '2px', flexDirection: 'column' }}>
						{activities.map(activity => (
							<Card
								key={activity._id}
								style={{
									width: '100%',
									backgroundColor: 'rgba(241, 241, 255, 0.3)',
									boxShadow: 'none',
									padding: '10px',
									marginTop: '12px',
									borderRadius: '12px',
									display: 'flex',
									flexDirection: 'column'
								}}
							>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'space-between',
										paddingRight: 100
									}}
								>
									<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
										<div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
											<Typography variant="body2" color="textSecondary">
												Status :
											</Typography>
											<Typography variant="body1" style={{ fontWeight: 'bold' }}>
												{activity.status}
											</Typography>
										</div>
										<div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
											<Typography variant="body2" color="textSecondary">
												Browser :
											</Typography>
											<Typography variant="body1" style={{ fontWeight: 'bold' }}>
												{activity.browser}
											</Typography>
										</div>
									</div>

									<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
										<div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
											<Typography variant="body2" color="textSecondary">
												OS :
											</Typography>
											<Typography variant="body1" style={{ fontWeight: 'bold' }}>
												{activity.os}
											</Typography>
										</div>

										<div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
											<Typography variant="body2" color="textSecondary">
												Timestamp :
											</Typography>
											<Typography variant="body1" style={{ fontWeight: 'bold' }}>
												{new Date(activity.timestamp).toLocaleDateString()}
											</Typography>
										</div>
									</div>

									<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
										<div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
											<Typography variant="body2" color="textSecondary">
												Time :
											</Typography>
											<Typography variant="body1" style={{ fontWeight: 'bold' }}>
												{new Date(activity.timestamp).toLocaleTimeString([], {
													hour: '2-digit',
													minute: '2-digit',
													hour12: true
												})}
											</Typography>
										</div>

										<div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
											<Typography variant="body2" color="textSecondary">
												Activity Name :
											</Typography>
											<Typography variant="body1" style={{ fontWeight: 'bold' }}>
												{activity.activitytype}
											</Typography>
										</div>
									</div>
								</div>
							</Card>
						))}
					</div>
				)}
			</Card>
		</div>
	)
}

export default UnusualActivities
